module.exports = __webpack_public_path__ + "img/logo_cmi.e7c711a0.png";